/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:mentor
 */

import * as Types from '../../types/mentor-gql';

import { api } from 'app/apis/mentor-gql-api';
export type MentorDash_UpdateMentorAgreementMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  mentor_id: Types.Scalars['String']['input'];
  status: Types.Status;
  date_signed?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  pay_rate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  hours_per_month?: Types.InputMaybe<Types.Scalars['String']['input']>;
  max_payments_per_month?: Types.InputMaybe<Types.Scalars['String']['input']>;
  bonus?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type MentorDash_UpdateMentorAgreementMutation = {
  __typename?: 'Mutation';
  updateAgreement?: {
    __typename?: 'Agreement';
    id?: string | null;
    mentor_id?: string | null;
    role?: Types.Role | null;
    status?: Types.Status | null;
    date_signed?: any | null;
    pay_rate?: string | null;
    hours_per_month?: string | null;
    max_payments_per_month?: string | null;
    bonus?: string | null;
    created_at?: any | null;
    updated_at?: any | null;
  } | null;
};

export const MentorDash_UpdateMentorAgreementDocument = `
    mutation MentorDash_UpdateMentorAgreement($id: String!, $mentor_id: String!, $status: Status!, $date_signed: Date, $pay_rate: String, $hours_per_month: String, $max_payments_per_month: String, $bonus: String) {
  updateAgreement(
    id: $id
    mentor_id: $mentor_id
    status: $status
    date_signed: $date_signed
    pay_rate: $pay_rate
    hours_per_month: $hours_per_month
    max_payments_per_month: $max_payments_per_month
    bonus: $bonus
  ) {
    id
    mentor_id
    role
    status
    date_signed
    pay_rate
    hours_per_month
    max_payments_per_month
    bonus
    created_at
    updated_at
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_UpdateMentorAgreement: build.mutation<
      MentorDash_UpdateMentorAgreementMutation,
      MentorDash_UpdateMentorAgreementMutationVariables
    >({
      query: (variables) => ({ document: MentorDash_UpdateMentorAgreementDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
